<div class="xvi-array-string-renderer">
  <div
    class="showing-items"
    [class.clickable]="!!linkClick"
    [ngClass]="itemClass"
    (click)="clickString()"
  >
    {{ stringValue }}
  </div>

  <div class="btn-group dropdown xux-dropdown" *ngIf="allButton">
    <span class="more-button dropdown-toggle" (click)="showDropdown($event)">
      {{ allButton }}
    </span>
  </div>
</div>
